import { render, staticRenderFns } from "./StructDisplayList.vue?vue&type=template&id=fcab8614&scoped=true&"
import script from "./StructDisplayList.vue?vue&type=script&lang=js&"
export * from "./StructDisplayList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcab8614",
  null
  
)

export default component.exports